const BUDGET = {
  NOT_FOUND: 'Budget not found or you do not have access to this budget.',
  EXPIRED_OR_CLAIMED: 'Budget expired or already claimed.',
  REFUND_REQUEST: 'Refund Requested.',
  APPROVED: 'Amount approved.',
  REJECTED: 'Amount rejected.',
  REFUNDED: 'Budget Refunded.',
} as const;

export default BUDGET;
